import { initialPortalPagesState, PORTAL_PAGES_ACTIONS } from './portalPages.types'
import type { PortalPagesAction, PortalPagesSlice } from './portalPages.types'

export function portalPagesReducer(
  state: PortalPagesSlice = initialPortalPagesState,
  action: PortalPagesAction
): PortalPagesSlice {
  switch (action.type) {
    case PORTAL_PAGES_ACTIONS.SET_PORTAL_PAGES_STATUS:
      return { ...state, status: action.payload }

    case PORTAL_PAGES_ACTIONS.SET_PORTAL_PAGES_ERRORS:
      return { ...state, errors: [action.payload, ...state.errors] }

    case PORTAL_PAGES_ACTIONS.SET_PORTAL_PAGE_DATA:
      return { ...state, data: { ...state.data, [action.payload.pageId]: action.payload } }

    case PORTAL_PAGES_ACTIONS.CLEAR_PORTAL_PAGES_ERRORS:
      return { ...state, errors: [] }

    case PORTAL_PAGES_ACTIONS.CLEAR_PORTAL_PAGES_DATA:
      return { ...state, data: {} }

    default:
      return state
  }
}
